import { REPORTS_TYPES } from 'constants/report';
import callAPiBase from './base';
// mock: temporary, remove with ./mock/automaticCharge.ts once the backend is deployed
import { isMockEnabled } from './mock';
import { automaticChargeMockApi } from './mock/automaticCharge';

const automaticChargeRealApi = {
  getStatus: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/automaticChargeStatus',
      method: 'GET',
      useToken: true,
      title: 'Automatic Charge - Get status',
      params,
    }),
  acceptContract: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/automaticChargeContractAccept',
      method: 'POST',
      useToken: true,
      title: 'Automatic Charge - Accept contract',
      data,
    }),
  enable: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/automaticChargeEnable',
      method: 'POST',
      useToken: true,
      title: 'Automatic Charge - Enable',
      data,
    }),
  updatePayoutAccount: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/automaticChargePayoutAccountUpdate',
      method: 'POST',
      useToken: true,
      title: 'Automatic Charge - Update payout account',
      data,
    }),
  dailyReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.AUTOMATIC_CHARGE_DAILY_RESUME}`,
      method: 'GET',
      useToken: true,
      title: 'Automatic Charge - Daily Report',
      params,
    }),
  historyDetail: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/automaticChargeHistoryDetail',
      method: 'GET',
      useToken: true,
      title: 'Automatic Charge - History Detail',
      params,
    }),
};

// mock: temporary, remove with ./mock/automaticCharge.ts once the backend is deployed
const automaticChargeApi = isMockEnabled('automaticCharge')
  ? automaticChargeMockApi
  : automaticChargeRealApi;

export { automaticChargeApi };
export default automaticChargeApi;
